import { useMemo } from 'react'
import { useGetEnumItemsQuery, useGetCustomersQueryQuery } from '../../../../api/plamo-api'
import { ActionTablePath } from '../../action-table/action-table'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { Link, useNavigate } from 'react-router-dom'
import { IconHouseSolid } from '../../../../icon'

const budgets = {
  "DA": "HH",
  "SA": "ELB",
  "CLSNG": "Beratung",
  "AC": "VP",
  "STC": "KP",
  "CONV": "U"
}

function CustomerListPage() {
  const navigate = useNavigate()
  const { data: statusEnumItems } = useGetEnumItemsQuery({ f: JSON.stringify({ "referencedEnum.ident": { c: 'EQ', v: 'customerStatus' }})}) as any

  const isLoading = false;
  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      filter: true,
      type: 'enum',
      typeAttrs: {
        items: statusEnumItems?.items || []
      },
      width: 100,
    },
    /*
    {
      title: "Wiedervorl.",
      dataIndex: "followUp",
      sorter: true,
      filter: true,
      type: 'date',
      typeAttrs: {
        items: statusEnumItems?.items || []
      },
      width: 100,
    },
    */
    {
      title: "Vorname",
      dataIndex: "firstName",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value, item) => <Link to={`/customer/${item.id}`}>{ value }</Link>
    },
    {
      title: "Nachname",
      dataIndex: "lastName",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value, item) => <Link to={`/customer/${item.id}`}>{ value }</Link>
    },
    {
      title: "Leistungen",
      dataIndex: "budgets",
      sorter: true,
      filter: true,
      type: 'separatedList',
      typeAttrs: {
        items: [
          {
            label: "Haushaltshilfe",
            value: "DA"
          },
          {
            label: "Entlastungsbetrag",
            value: "SA"
          },
          {
            label: "Beratung",
            value: "CLSNG"
          },
          {
            label: "Verhinderungspflege",
            value: "AC"
          },
          {
            label: "Umwandlung",
            value: "CONV"
          }          
        ]
      },
      render: (value) => value?.split("#").filter(e => e.length !== 0).map(e => budgets[e]).join(", ")
    },
  ], [statusEnumItems?.items])

  return (
    <div>
      <Breadcrumb
          style={{ marginBottom: "24px" }}
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined/>,
            },
            {
              title: (
                <>
                  <IconHouseSolid />
                  <span>Kunden</span>
                </>
              ),
            },         
          ]}
        />
      <ActionTablePath
          storageKey="customer"
          isParentLoading={isLoading}
          defaultSortKey="lastName"
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                onClick: () => navigate('./new')
              },
              {
                text: 'Suche zurücksetzen',
                onClick: () => navigate(`?filter=${btoa(JSON.stringify({ status: { comparator: "EQ", value: "Aktiv", originalValue: "Aktiv", displayValue: "Aktiv", title: "Status" }}))}`)
              }
            ]
          }}
          tableData={{
            defaultSortKey: 'lastName',
            columns,
            dataSource: {
              pageableQueryEndpoint: useGetCustomersQueryQuery,
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Bearbeiten',
                onClick: (item) => navigate(`./${item.id}`)
              },
              /*
              {
                caption: 'Löschen',
                danger: true,
                onClick: (item) => deleteCustomer(item)
              }
                */
            ]
          }}
        />

    </div>
  )
}

export default CustomerListPage